import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const VerifyProfile = lazy(() => import("@/pages/VerifyProfile"));

export const Route = createFileRoute("/verify-profile")({
  component: VerifyProfile,
});
